module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\n<img src="'+
((__t=( icon ))==null?'':_.escape(__t))+
'" class="docicon" />\n<div class="grid4">\n  <strong>'+
((__t=( name ))==null?'':_.escape(__t))+
'</strong><br/>\n  '+
((__t=( extension ))==null?'':_.escape(__t))+
'\n  ';
 if(caution){ 
__p+='\n  <img src="/static/images/icon-warning.gif" />\n  PDFs are reconmended!\n  ';
 } 
__p+='\n</div>\n';
 if(mode == "list") { 
__p+='\n<a class="button button-secondary removeButton">\n  Remove from list\n</a>\n';
 } else if(mode == "select"){ 
__p+='\n<a class="button selectButton">\n  Select\n</a>\n';
 } 
__p+='\n<a class="button button-secondary" target="_blank" href="'+
((__t=( url ))==null?'':_.escape(__t))+
'">\n  Download\n</a>\n<div class="clear"></div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/attachments/item.html
// module id = 280
// module chunks = 0